class LacePopProductVideo extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    this.slide = this.closest('slideshow-slide');
    this.wantsVideo = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.button.hidden = false;
    this.button.textContent = 'Video';
    this.button.setAttribute('aria-label', 'Show product video');
    this.addEventListener('click', event => event.stopPropagation(), { signal });
    this.button.addEventListener('click', () => {
      this.wantsVideo = !this.wantsVideo;
      if (this.wantsVideo) this.start();
      else { this.video.pause(); this.showPhoto(); }
    }, { signal });
    this.video.addEventListener('playing', () => {
      if (!this.wantsVideo) return;
      this.setAttribute('data-playing', '');
      this.button.textContent = 'Photo';
      this.button.setAttribute('aria-label', 'Show product photo');
    }, { signal });
    this.video.addEventListener('error', () => { this.showPhoto(); this.button.hidden = true; }, { signal });
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      this.sync();
    }, { threshold: 0.25 });
    this.observer.observe(this);
    this.mutation = new MutationObserver(() => this.sync());
    if (this.slide) this.mutation.observe(this.slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    document.addEventListener('visibilitychange', () => this.sync(), { signal });
  }
  start() {
    if (!this.video.src) this.video.src = this.dataset.src;
    this.video.muted = true;
    this.video.play().catch(() => { this.wantsVideo = false; this.showPhoto(); });
  }
  sync() {
    const visible = this.inView && !document.hidden && this.slide?.getAttribute('aria-hidden') !== 'true';
    if (visible && this.wantsVideo) this.start();
    else this.video.pause();
  }
  showPhoto() {
    this.removeAttribute('data-playing');
    this.button.textContent = 'Video';
    this.button.setAttribute('aria-label', 'Show product video');
  }
  disconnectedCallback() {
    this.video?.pause();
    this.controller?.abort();
    this.observer?.disconnect();
    this.mutation?.disconnect();
  }
}
if (!customElements.get('lp-product-video')) customElements.define('lp-product-video', LacePopProductVideo);
